import { render, staticRenderFns } from "./teamMember.vue?vue&type=template&id=f4b5bf76&scoped=true&"
import script from "./teamMember.vue?vue&type=script&lang=js&"
export * from "./teamMember.vue?vue&type=script&lang=js&"
import style0 from "./teamMember.vue?vue&type=style&index=0&id=f4b5bf76&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f4b5bf76",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('f4b5bf76')) {
      api.createRecord('f4b5bf76', component.options)
    } else {
      api.reload('f4b5bf76', component.options)
    }
    module.hot.accept("./teamMember.vue?vue&type=template&id=f4b5bf76&scoped=true&", function () {
      api.rerender('f4b5bf76', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-203o1cdn0pv03/JS/teamMember.vue"
export default component.exports